export const FEEDBACK_STATUS = {
	POOR: 101,
	BAD: 102,
	AVERAGE: 103,
	GOOD: 104,
	PERFECT: 105,
} as const;
export type TFeedbackStatus = typeof FEEDBACK_STATUS[keyof typeof FEEDBACK_STATUS];


export const FEEDBACK_STATUS_LABELS: Record<TFeedbackStatus, string> = {
	[FEEDBACK_STATUS.POOR]: 'Poor',
	[FEEDBACK_STATUS.BAD]: 'Bad',
	[FEEDBACK_STATUS.AVERAGE]: 'Average',
	[FEEDBACK_STATUS.GOOD]: 'Good',
	[FEEDBACK_STATUS.PERFECT]: 'Excellent', // This is what PHP calls it
};
